import { render } from "./WorkloadApprovalDialog.vue?vue&type=template&id=296d4e37&scoped=true"
import script from "./WorkloadApprovalDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadApprovalDialog.vue?vue&type=script&lang=js"

import "./WorkloadApprovalDialog.vue?vue&type=style&index=0&id=296d4e37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296d4e37"]])

export default __exports__